import React, { FunctionComponent } from "react"
import { Line } from "react-chartjs-2"
import { ChartData, ChartOptions, DefaultDataPoint } from "chart.js"
import { uniformSample } from "@components/Distribution/UniformDistributionChart/uniform.calc"

interface Props {
  loc: number
  scale: number
  lbound?: number
  ubound?: number
}

export const UniformDistributionChart: FunctionComponent<Props> = ({
  loc = 0,
  scale = 1,
  lbound = undefined,
  ubound = undefined,
}) => {
  // https://docs.scipy.org/doc/scipy/reference/generated/scipy.stats.uniform.html
  // Using the parameters loc and scale, one obtains the uniform distribution on [loc, loc + scale]
  scale = loc + scale
  const { data, labels } = uniformSample(loc, scale, lbound, ubound)
  const pdfValue = 1 / (scale - loc)

  const chartData: ChartData<"line", DefaultDataPoint<"line">, number> = {
    labels,
    datasets: [
      {
        data,
        borderWidth: 3,
        pointRadius: 0, // No points on the line
        fill: true, // Fill the area under the curve
        stepped: false, // We created the steps manually for sharp edges
        tension: 0, // Makes lines straight between points
      },
    ],
  }
  const chartOptions: ChartOptions<"line"> = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      x: {
        type: "linear", // Use a linear scale for x-axis
        title: {
          display: true,
          text: "Value",
        },
      },
      y: {
        title: {
          display: true,
          text: "Probability Density",
        },
        // Set a slightly higher max to give some space above the curve
        max: pdfValue * 1.1,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  }
  return <Line options={chartOptions} data={chartData}></Line>
}
